import { _podcastReducer } from './_podcast/reducers';

export { _podcastReducer };
